<template>
  <el-dialog
    title="提示"
    :visible.sync="verificationVisible"
    width="40%"
    :before-close="handleClose"
  >
    <el-form
      :model="data"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      label-suffix=":"
      class="demo-ruleForm"
    >
      <el-form-item label="款项名称" prop="paymentTitle">
        {{ data.collectTitle }}
      </el-form-item>
      <el-form-item label="收款金额" prop="paymentAmount">
        {{ getMoney(data.collectionAmount) }}
      </el-form-item>
      <el-form-item label="实际收款日期" prop="planDate">
        {{ data.actualCollectDate }}
      </el-form-item>
      <!-- <el-form-item label="客户经理" prop="managerName">
     {{data.contract.managerName}}
  </el-form-item> -->
      <el-form-item label="收款人开户行" prop="payOpeningBank">
        {{ data.collectOpeningBank }}
      </el-form-item>
      <el-form-item label="收款人户名" prop="payAccountName">
        {{ data.collectAccountName }}
      </el-form-item>
      <el-form-item label="收款人账号" prop="payBankAccount">
        {{ data.collectBankAccount }}
      </el-form-item>
    </el-form>
    <span class="but_right">
      <el-button @click="verificationVisible = false">取 消</el-button>
      <el-button type="primary" @click="verificheck()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      verificationVisible: false,
      data: {
        verificationTime: "",
      },
      rules: {
        verificationTime: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
      },
    };
  },
  watch: {
    verificationVisible: {
      handler(newname, oldname) {
        if (oldname != undefined && newname == false) {
          this.$refs.ruleForm.resetFields();
        }
      },
    },
  },
  methods: {
    showblock(data) {
      this.verificationVisible = true;
      this.data = data[0];
      this.data.verificationTime = "";
    },
    showblockdetail(data) {
      this.verificationVisible = true;
      this.data = data;
      this.data.verificationTime = "";
    },
    // verificheck(){
    //     let that=this
    //     this.$refs.ruleForm.validate((valid) => {
    //         if(valid){
    //
    //             that.$emit("verificheckreturn",that.data)
    //             that.verificationVisible=false
    //
    //         }
    //     })
    // }
    verificheck() {
      let that = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let { data } = this;
          that.$emit("verificheckreturn", {
            id: data.id,
            verificationTime: data.veridaficationTime,
          });
          that.verificationVisible = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__header {
  border-bottom: 1px solid #e4e4e4e4;
  line-height: 55px;
  // padding-left: 25px;
}
/deep/.el-dialog__body {
  padding: 0px;
}
/deep/.demo-ruleForm {
  padding: 30px 50px;
}
/deep/ .el-form-item {
  margin-bottom: 0px;
}
/deep/.el-form-item__label {
  color: #999999;
}
/deep/.el-form-item__content {
  border-bottom: 1px solid #e4e4e4e4;
  padding-left: 3px;
}
.but_right {
  border-top: 1px solid #e4e4e4e4;
  display: inline-block;
  margin-top: 5px;
  margin-bottom: 17px;
  padding-right: 25px;
  padding-top: 17px;
  width: 100%;
  text-align: right;
}
/deep/.el-dialog__header {
  padding: 0px 25px;
}
</style>